import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { COMMON_LABEL_CLASSES } from 'dpl/shared/form/utils/constants';

export default function Label({
  htmlFor,
  required,
  text
}) {
  return (
    <label
      className={ classnames('Label', { dn: !text }) }
      htmlFor={ htmlFor }
    >
      <span className="mb1 db">
        <span className="flex align-items-center">
          <span className="flex-auto">
            <span className={ classnames('Label__text', COMMON_LABEL_CLASSES) }>
              { text }
              {
                required &&
                  <abbr className="purple" title="required" aria-label="required">*</abbr>
              }
            </span>
          </span>
        </span>
      </span>
    </label>
  );
}

Label.propTypes = {
  htmlFor: PropTypes.string,
  required: PropTypes.bool,
  text: PropTypes.string
};

Label.defaultProps = {
  htmlFor: null,
  required: false,
  text: null
};
